@use "variables" as *;

.cabinet {
  position: relative;
  display: flex;
  align-self: center;
  justify-self: center;
  border-top: 5px solid transparent;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 30px solid transparent;
  box-sizing: border-box;
  box-shadow: 0 0 10px #222;
  -webkit-box-shadow: 0 0 10px #222;
  -moz-box-shadow: 0 0 10px #222;
}

.piperLogo {
  position: absolute;
  bottom: -28px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 30px;
  filter: drop-shadow(0 0 4px #000);
}
